export enum StorageAccountState {
  FullyAccessible = 0,
  ReadOnly = 1,
  Disabled = 2,
  Deleted = 3
}
